module.exports = __webpack_public_path__ + "img/cxTrends-1.0dcc11fc.png";